import React from 'react'
import SafetyEventsDashboard from '../safetyEvents'

const NbSafetyEvents: React.FC = () => {
    return <SafetyEventsDashboard useKilometers={true} />
}

export default NbSafetyEvents
